import type React from 'react';

import { useEnsureTriggers } from '../hooks/useEnsureTriggers';

/**
 * Invisible driver for the ambiguous-transport TP/SL recovery. When an OPEN
 * trade requested a TP/SL leg that was never installed (the open timed out on
 * the FE but Hyperliquid accepted it; factions later flipped it to Open),
 * {@link useEnsureTriggers} detects it and auto-calls the MoonHub install
 * endpoint. Renders nothing by design — the restore is silent and the position
 * itself is already live; only a restore FAILURE surfaces to the user (via the
 * hook's error toast). Mounting this component is what drives the auto-call.
 */
const RestoreTriggersIndicator: React.FC = () => {
    useEnsureTriggers();
    return null;
};

RestoreTriggersIndicator.displayName = 'RestoreTriggersIndicator';

export default RestoreTriggersIndicator;
